<template>

    <Card :header="header">

        <template #nav>
            <div class="d-flex gap-3">
                <ButtonIcon
                    variant="primary"
                    :disabled="loading"
                    :loading="false"
                    @click="editSet()"
                >
                    {{ $t('editSet') }}
                </ButtonIcon>
                <ButtonIcon
                    variant="secondary"
                    :disabled="false"
                    :loading="false"
                    @click="closeSet()"
                >
                    {{ $t('close') }}
                </ButtonIcon>
            </div>
        </template>

        <div class="d-flex gap-4 flex-column">

            <RankingTable
                :items="items"
                :loading="loading"
                :error="error"
                :actions="false"
                no-local-sorting
            />

            <div class="dropdown-divider border-bottom border-light"></div>

            <ChangeOfAveragePriceOverTime />

            <div class="dropdown-divider border-bottom border-light"></div>

            <PriceRangeAndDeviations />

            <div class="dropdown-divider border-bottom border-light"></div>

            <NumberOfOffers />

            <div class="dropdown-divider border-bottom border-light"></div>

            <AvailabilityInStores />

        </div>

    </Card>

</template>



<script>
    import RankingTable from './RankingTable.vue';
    import ChangeOfAveragePriceOverTime from './ChangeOfAveragePriceOverTime.vue';
    import PriceRangeAndDeviations from './PriceRangeAndDeviations.vue';
    import NumberOfOffers from './NumberOfOffers.vue';
    import AvailabilityInStores from './AvailabilityInStores.vue';

    export default {
        name: 'CurrentItem',
        components: {
            RankingTable,
            ChangeOfAveragePriceOverTime,
            PriceRangeAndDeviations,
            NumberOfOffers,
            AvailabilityInStores,
        },
        inject: {
            parentComponent: {
                default: null,
            },
        },
        provide() {
            return {
                parentComponent: this,
            };
        },
        data() {
            return {
                requestReportSet: this.parentComponent.requestSpacesCompetitionReportSet,
                requestReport: this.parentComponent.requestSpacesCompetitionReport,
            };
        },
        computed: {
            loading() {
                return this.parentComponent.loading;
            },
            error() {
                return this.parentComponent.error;
            },
            productSet() {
                return this.parentComponent.productSet;
            },
            currentItem() {
                return this.parentComponent.currentItemToShow;
            },
            header() {
                return this.currentItem?.name;
            },
            items() {
                // 1) Brak currentItem albo dane w trakcie ładowania → pusta lista.
                if (!this.currentItem?.reportId || this.loading) return [];

                // 2) Znajdź set odpowiadający bieżącemu wierszowi (po reportId).
                const currentSet = this.productSet.find(setEntry => setEntry.reportId === this.currentItem.reportId);
                if (!currentSet) return [];

                // 3) Weź pełną listę produktów setu (main + powiązane).
                const productsInSet = currentSet.allProducts || [];
                if (!productsInSet.length) return [];

                // 4) Zbuduj wiersze tabeli: dla każdego produktu policz dane w kontekście całego setu.
                return (
                    productsInSet
                        .map(productMeta => this.parentComponent.getDataForSet(productsInSet, productMeta.id, productMeta.type))
                        .filter(Boolean)
                        // 5) Main na górze, reszta pod spodem.
                        .sort((left, right) => (left.type === 'main' ? -1 : right.type === 'main' ? 1 : 0))
                        // 6) Opcjonalne wyróżnienie wiersza main.
                        .map(row => ({ ...row, _rowVariant: row.type === 'main' && 'secondary' }))
                );
            },
        },
        methods: {
            editSet() {
                this.parentComponent.createSet(this.currentItem);
            },
            closeSet() {
                this.parentComponent.hideItem();
            },
            getDataForSet(...params) {
                return this.parentComponent.getDataForSet(...params);
            },
        },
    };
</script>
